import React from 'react';

export default function ListItemCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.2"
        d="M2.5 12.5C2.5 8.02166 2.5 5.78249 3.89124 4.39124C5.28249 3 7.52166 3 12 3C16.4783 3 18.7175 3 20.1088 4.39124C21.5 5.78249 21.5 8.02166 21.5 12.5C21.5 16.9783 21.5 19.2175 20.1088 20.6088C18.7175 22 16.4783 22 12 22C7.52166 22 5.28249 22 3.89124 20.6088C2.5 19.2175 2.5 16.9783 2.5 12.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M8 13L10.5 15.5L16 9.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
